export const FOLD_ICON_OPTION = 'FOLD_ICON_OPTION';
export const FOLD_ICON_CHEVRON = 'FOLD_ICON_CHEVRON';
export const FOLD_ICON_POSITION_LEFT = 'FOLD_ICON_POSITION_LEFT';
export const FOLD_ICON_POSITION_RIGHT = 'FOLD_ICON_POSITION_RIGHT';
